import { headerBgGradient2 } from './HeaderBgStore';

import { headerBgGradient2Default } from './HeaderBgStoreDefaults';

export const resetHeaderBgGradient2 = () => headerBgGradient2.set(headerBgGradient2Default);
